import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import ContactMethods from "../components/contact/ContactMethods";
import ContactInfo from "../components/contact/ContactInfo";
import GlobalCta from "../components/global/GlobalCta";

import { contactSections } from "../components/contact/contactSections";

const ContactUs = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "contact-hero":
        return (
          <ContactHero
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "contact-methods":
        return <ContactMethods key={index} />;

      case "contact-info":
        return <ContactInfo key={index} />;

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            description={section.description}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Chiller Fleet Transport | Refrigerated Truck &amp; Van Rental Dubai</title>
        <meta name="description" content="Get in touch with Chiller Fleet Transport to book refrigerated trucks and vans for rent across Dubai, Sharjah, and UAE. Call or WhatsApp our team directly." />
        <meta property="og:title" content="Contact Chiller Fleet Transport | Refrigerated Truck & Van Rental Dubai" />
        <meta property="og:description" content="Get in touch with Chiller Fleet Transport to book refrigerated trucks and vans for rent across Dubai, Sharjah, and UAE. Call or WhatsApp our team directly." />
        <link rel="canonical" href="https://chillerfleet.com/contact-us" />
        <meta property="og:url" content="https://chillerfleet.com/contact-us" />
        <meta name="twitter:title" content="Contact Chiller Fleet Transport | Refrigerated Truck & Van Rental Dubai" />
        <meta name="twitter:description" content="Get in touch with Chiller Fleet Transport to book refrigerated trucks and vans for rent across Dubai, Sharjah, and UAE. Call or WhatsApp our team directly." />
      </Helmet>

      {contactSections.map(renderSection)}
    </>
  );
};

export default ContactUs;
